import * as Html from "../util/Html.ts";
import * as blackveil from "../lib/blackveil2.js";

export {init}
Html.registerWidget('widget/dropdown',{init:init})

Html.register({
  opendropdown(){
    var 
      item=this,
      ancestorSelector = this.attr('data-fw-dropdown-root'),
      commentedSelector = this.attr('data-fw-dropdown-commented'),
      root = this.parents(ancestorSelector).first(),
      blackveilRootSelector = this.attr('data-fw-blackveil-root'),
      blackveilRoot = blackveilRootSelector?(blackveilRootSelector==='.'?this:this.parents(blackveilRootSelector)):root,
      commented = root.find(commentedSelector),
      zIndex = item.data('dropdown-zindex')||9,
      closing = false,
      close,
      open;
    
    close = function (evt){
      closing = true;
      setTimeout(function(){closing=false;})
      blackveil.hide(blackveilRoot);
      root.removeClass('fw-open');
      root.removeClass('fw-open-upper');
      root.removeClass('fw-open-middle');
      root.off('click',close);
      $(document).off('click',close);
    };
    open = function(){
      blackveil.show(blackveilRoot,zIndex).on('click',close);
      Html.enableComments(commented);
      commented.show()
      
      root.addClass('fw-open');
      var 
        rect = item.get(0).getClientRects()[0],
        rectBody = $('body').get(0).getClientRects()[0];
      
      if(rect){
        var delta = rectBody.height - rect.bottom;
        if(Math.abs(delta-rect.top)<100){
          root.addClass('fw-open-middle');
        }else if(delta<rect.top){
          root.addClass('fw-open-upper');
        }        
      }
    };
    root.swipe({
      swipeUp:close
    });
    
    if(closing){
    }if(root.hasClass('fw-open')){
      close()
    }else{
      open() 
    }
    return true;
  }
});

function init(o){
  if(!o.attr('data-fw-onclick')){
    o.attr('data-fw-onclick','opendropdown');
  }
}
